<template>
  <div class="container">
    <div class="row">
      <div class="logo">
        <img src="monorevo_logo_fix-black.svg" />
      </div>
    </div>
    <div class="row">
      <form class="w-100" autocomplete="off" @submit.prevent="send">
        <div class="card mb-3">
          <div class="card-header">
            <h4>{{ $t("パスワードリセット")}}</h4>
          </div>
          <div class="card-body">
            <div class="form-group" style="font-size: 1.1rem; margin-bottom: 30px;">
              {{ $t("会社ID（メールアドレス）とログインIDを入力して下さい") }}
            </div>
            <div class="form-group">
              <label for="inputCompany">{{ $t("会社ID（メールアドレス）") }}</label>
              <input
                type="email"
                name="email"
                class="form-control"
                autofocus
                required
                id="inputCompany"
                v-model="company_id"
              />
            </div>
            <div class="form-group">
              <label for="inputLoginId">{{ $t("ログインID") }}</label>
              <input
                type="text"
                name="login_id"
                id="inputLoginId"
                class="form-control"
                autofocus
                maxlength="50"
                v-model="login_id"
                required
              />
            </div>
            <div class="form-group" style="margin: 30px auto;">
              <div class="float-left" style="width: 45%; margin-right: 10%;">
                <button type="button" class="btn btn-lg btn-light btn-block" @click="onClickCancel">
                  {{ $t("キャンセル") }}
                </button>
              </div>
              <div class="float-left" style="width: 45%;">
                <button class="btn btn-lg btn-success btn-block" type="submit">
                  <font-awesome-icon :icon="['fas', 'envelope-square']" />
                  &nbsp;{{ $t("送信") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lostpassword',
  data() {
    return {
      company_id: '',
      login_id: '',
      pageTitle: 'パスワードリセット',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    onClickCancel() {
       window.location.href = this.$appConfig.ScreenUrl.login
    },
    send() {
      this.$store
        .dispatch('auth/forgetPassword', {
          company_id: this.company_id,
          login_id: this.login_id,
        })
        .then(() => {
          const input_code_page = 'lostpasswordcode.html'
          const company_id = 'company_id=' + this.company_id
          const login_id = 'login_id=' + this.login_id
          window.location.href =
            input_code_page + '?' + company_id + '&' + login_id
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/common-page.scss";
</style>
